import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';
import { Button } from 'components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../menu-icon/menu-icon';
import {useEffect, useState} from 'react';
import { useSignatureResponse } from "pages/hooks/use-home";
import {getAvailableApps, handleConfigItemClick} from 'pages/home/models/homeConfigs';
import { useTranslation } from 'react-i18next';
import {useCommonStore} from "state/store/common/useCommonStore";

export const AppSwitcher = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync } = useSignatureResponse();

  const [open, setOpen] = useState(false);
  const [colSpan, setColSpan] = useState(2);
  const isAdmin = useCommonStore((state) => state.isAdmin);
  
  useEffect(()=>{
    if (isAdmin) {
      setColSpan(3);
    }
  }, [isAdmin]);
  
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="icon" className="rounded-full hover:bg-muted">
          <Icon name="LayoutGrid" className="!w-5 !h-5 text-sm" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[350px] sm:w-[464px] p-3 rounded-2xl" align="center">
        <div className={`grid grid-cols-${isAdmin? 2 : 1} md:grid-cols-${colSpan} gap-1`}>
          {getAvailableApps(isAdmin)?.map((item, index) => (
            <div
              onClick={() => {
                setOpen(false);
                handleConfigItemClick(item, navigate, mutateAsync);
              }}
              key={index}
              className="flex flex-col items-center justify-start p-4 rounded-lg hover:bg-muted transition-colors cursor-pointer"
            >
              <div className="w-8 md:w-11 h-8 md:h-11">
                {item.icon}
              </div>
              <span className="md:text-base font-semibold text-center text-sm mt-4">
                {t(item.title)}
              </span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
